import * as selectors from './selectors';

const getShopMenu = (categoryName) => {
    return (_dispatch, getState) => {
        const items = selectors.selectShopCategoryMenu(getState(), categoryName);
        return items;
    };
};

export default getShopMenu;
